import { PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { UserGeneralCard } from '../components'

export const UsersCreatePage = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      items={[
        {
          title: t('menu.users'),
          path: paths.users.root
        },
        {
          title: t('users.create_new_user')
        }
      ]}
      title={t('users.create_new_user')}
    >
      <UserGeneralCard />
    </PageBreadcrumbs>
  )
}
